import { render, staticRenderFns } from "./GolfConveniosCampos.vue?vue&type=template&id=13b6638e"
import script from "./GolfConveniosCampos.vue?vue&type=script&lang=js"
export * from "./GolfConveniosCampos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports